import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/Common";
import { homeFor } from "@/lib/api";

export default function ProtectedRoute({ role, children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
  if (role && !user.roles?.includes(role)) return <Navigate to={homeFor(user)} replace />;
  return children;
}
